module.exports = __webpack_public_path__ + "static/media/chinese-categories.24a922b7.jpg";